// Campaign statuses
const campaignStatusEnum = Object.freeze({
  live: 'CampaignsList_Status_Live',
  past: 'CampaignsList_Status_Past',
  scheduled: 'CampaignsList_Status_Scheduled',
  draft: 'CampaignsList_Status_Draft',
  disabled: 'CampaignsList_Status_Disabled'
})

export { campaignStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/CampaignStatusEnum.js